export default "mutation requestContact($input: ContactInput!) {\n  requestContact(input: $input)\n}";